import {Button, Col, Form, Modal, Row, Spinner} from "react-bootstrap";
import BaseModalSmall from "../BaseModalSmall";
import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {
    actionChangeHandelModalAddDiscountCode,
    actionChangeInputsModalAddDiscountCode
} from "../../../../../redux/actions/modals/modalAddDiscountCode";
import Axios from "axios";
import {BASE_URL, DISCOUNT_CODE_POST} from "../../../../../apis";
import qs from "querystring";
import {toast} from "react-toastify";
import {actionAddItemInInvoice, actionRemoveItemInInvoice} from "../../../../../redux/actions/modals/modalShoppingCard";
import _ from "lodash";

const ModalAddDiscountCode = () => {
    const dispatch = useDispatch();
    const {
        statusShow,
        discountCode,
        statusLoader,
        statusSet,
        result_discount,
        my_codes
    } = useSelector(state => state.modalAddDiscountCode);
    const {token} = useSelector(state => state.user);
    const {invoice} = useSelector(state => state.modalShoppingCard);
    const handleClose = () => {
        dispatch(actionChangeHandelModalAddDiscountCode(false));
        if (!statusSet) {
            handleEmptyInputCode();
        }
    };

    const handleCloseInCode = () => {
        dispatch(actionChangeHandelModalAddDiscountCode(false));
    };

    const handleChangeInputsModalAddDiscountCode = (event) => {
        const {value, name} = event.target;
        dispatch(actionChangeInputsModalAddDiscountCode(name, value));
    }
    const handleAddDiscountCode = () => {
        apiSendCode();
    }
    const apiSendCode = async () => {
        const TOTAL_PRODUCT = invoice.items.find(item => (Object.keys(item).toString() === 'مجموع'))['مجموع'].replace(",", "");
        dispatch(actionChangeInputsModalAddDiscountCode('statusLoader', true));
        try {
            const response = await Axios.post(BASE_URL + DISCOUNT_CODE_POST, qs.stringify({code: discountCode}), {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': token
                },
            });
            const {data} = response;

            switch (data.status) {
                case 'ok':

                    if (data.min_purchase_amount < parseInt(TOTAL_PRODUCT)) {
                        dispatch(actionChangeInputsModalAddDiscountCode('statusSet', true));
                        dispatch(actionChangeInputsModalAddDiscountCode('max_discount_price', data.max_discount_price));
                        dispatch(actionChangeInputsModalAddDiscountCode('amount', data.amount));
                        if (data.amount.search("%") !== -1) {
                            let base_amount = parseInt(invoice.items.find(key => key['مجموع'])['مجموع'].replace(",", ''));

                            const RESULT_DISCOUNT = (base_amount - (base_amount * ((100 - parseInt(data.amount.replace("%", ''))) / 100)));

                            if (parseInt(data.max_discount_price) === 0 || RESULT_DISCOUNT < data.max_discount_price) { 
                                dispatch(actionChangeInputsModalAddDiscountCode('result_discount', RESULT_DISCOUNT));
                                // eslint-disable-next-line
                                dispatch(actionAddItemInInvoice({['تخفیف']: (RESULT_DISCOUNT + ' تومان')}));
                            } else {
                                dispatch(actionChangeInputsModalAddDiscountCode('result_discount', data.max_discount_price));
                                // eslint-disable-next-line
                                dispatch(actionAddItemInInvoice({['تخفیف']: (data.max_discount_price + ' تومان')}));
                            }
                        } else {
                            dispatch(actionChangeInputsModalAddDiscountCode('result_discount', parseInt(data.amount)));
                            // eslint-disable-next-line
                            dispatch(actionAddItemInInvoice({['تخفیف']: (parseInt(data.amount) + ' تومان')}));
                        }
                        toast.success('کد تخفیف با موفقیت اعمال شد', {position: toast.POSITION.BOTTOM_CENTER});
                        handleCloseInCode();
                    } else {
                        toast.error(`حداقل مبلغ خرید جهت استفاده از این کد ${parseInt(data.min_purchase_amount).toLocaleString()} تومان میباشد.`, {position: toast.POSITION.BOTTOM_CENTER});
                    }
                    break;
                case 'error':
                    toast.error(data.message, {position: toast.POSITION.BOTTOM_CENTER});
                    break;
                default:
                    toast.error('لطفا مجددا تلاش کنید', {position: toast.POSITION.BOTTOM_CENTER});

            }
            if (data) {
                dispatch(actionChangeInputsModalAddDiscountCode('statusLoader', false));
            }
        } catch (e) {
            dispatch(actionChangeInputsModalAddDiscountCode('statusLoader', false));
            toast.error('لطفا مجددا تلاش کنید', {position: toast.POSITION.BOTTOM_CENTER});
            console.log(e);
        }
    }

    const handleRemoveDiscountCode = () => {
        dispatch(actionChangeInputsModalAddDiscountCode('statusSet', false));
        dispatch(actionChangeInputsModalAddDiscountCode('discountCode', ''));
        dispatch(actionRemoveItemInInvoice('تخفیف', result_discount));
    }

    const handleEmptyInputCode = () => {
        dispatch(actionChangeInputsModalAddDiscountCode('discountCode', ''));
    }

    useEffect(() => {
        if (statusShow) {
            dispatch({type: "FETCH_SHOW_MY_DISCOUNT", payload: {token}});
        }
        // eslint-disable-next-line
    }, [statusShow]);

    const selectedCode = (code) => {
        dispatch(actionChangeInputsModalAddDiscountCode('discountCode', code));
    }

    return (
        <BaseModalSmall title={'ورود کد تخفیف'}
                        show={statusShow}
                        dialogClassName={'cm-modal-add-discount-code'}
                        handleClose={handleClose}>
            <Modal.Body>
                <div className='box-show-list-discounts'>
                    {my_codes.length > 0 &&
                    <ul>
                        {_.map(my_codes, (code, index) =>
                            <li key={index} onClick={() => selectedCode(code.code)} className={code.code === discountCode ? 'bg-selected' : ''}>
                                <span>{code.code}</span>
                                <span>{code.amount}</span>
                                <span>{code.expire_date}</span>
                            </li>
                        )}
                    </ul>
                    }
                </div>
                <Form onSubmit={handleAddDiscountCode}>
                    <Form.Group controlId="input-form-add-price">
                        <Form.Label>
                            {statusSet ? <span>کد تخفیف اعمال شده</span> : <span>لطفا کد تخفیف را وارد کنید</span>}
                        </Form.Label>
                        <Form.Control type="text" name={'discountCode'}
                                      className={statusSet ? 'text-success text-center' : 'text-center'}
                                      value={discountCode} onChange={handleChangeInputsModalAddDiscountCode}
                                      placeholder="کد تخفیف" disabled={statusSet}/>
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Row className={'w-100'}>
                    <Col xs={6}>
                        {statusSet ?
                            <Button variant="success" className={'base-btn-green btn-sm'}
                                    onClick={handleRemoveDiscountCode}
                                    block>حذف کد تخفیف</Button>
                            :
                            <Button variant="success" className={'base-btn-green btn-sm'}
                                    onClick={handleAddDiscountCode} disabled={statusLoader}
                                    block>
                                {statusLoader ?
                                    <Spinner className={'mb-1 mr-2'}
                                             animation="border" size="sm"
                                             variant="danger"/>
                                    : null
                                }
                                <span>اعمال کد</span>
                            </Button>
                        }
                    </Col>
                    <Col xs={6}>
                        <Button variant="success" className={'base-btn-green-border btn-sm'} block
                                onClick={handleClose}>
                            انصراف
                        </Button>
                    </Col>
                </Row>
            </Modal.Footer>
        </BaseModalSmall>
    );
}

export default ModalAddDiscountCode;
